import * as m from "~/paraglide/messages.js";
import type { ServicePage } from "./types";

export function getN8nPage(): ServicePage {
  return {
    art: {
      bar: {
        mark: true,
        marker: m.services_flow_marker(),
        title: m.svc_n8n_art_bar(),
      },
      kind: "queue",
      // One run waits on a person: the workflow stops instead of guessing.
      rows: [
        { label: m.svc_n8n_art_row_1(), state: m.svc_n8n_art_state_1() },
        {
          flagged: true,
          label: m.svc_n8n_art_row_2(),
          state: m.svc_n8n_art_state_2(),
        },
        { label: m.svc_n8n_art_row_3(), state: m.svc_n8n_art_state_3() },
        { label: m.svc_n8n_art_row_4(), state: m.svc_n8n_art_state_4() },
      ],
    },
    artNote: m.svc_n8n_art_note(),
    capabilityId: "save-time",
    cta: { lede: m.svc_n8n_cta_lede(), title: m.svc_n8n_cta_title() },
    faq: [
      {
        answer: m.svc_n8n_faq_1_answer(),
        question: m.svc_n8n_faq_1_question(),
      },
      {
        answer: m.svc_n8n_faq_2_answer(),
        question: m.svc_n8n_faq_2_question(),
      },
      {
        answer: m.svc_n8n_faq_3_answer(),
        question: m.svc_n8n_faq_3_question(),
      },
      {
        answer: m.svc_n8n_faq_4_answer(),
        question: m.svc_n8n_faq_4_question(),
      },
    ],
    intro: m.svc_n8n_intro(),
    keywords:
      "n8n automation agency, n8n development services, n8n AI automation, AI workflow automation, AI workflow development, AI process automation, business AI automation, n8n automatizācija, biznesa procesu automatizācija",
    label: m.svc_n8n_label(),
    limits: {
      body: m.svc_n8n_limits_body(),
      items: [
        {
          term: m.svc_n8n_limit_1_term(),
          value: m.svc_n8n_limit_1_value(),
        },
        {
          term: m.svc_n8n_limit_2_term(),
          value: m.svc_n8n_limit_2_value(),
        },
        {
          term: m.svc_n8n_limit_3_term(),
          value: m.svc_n8n_limit_3_value(),
        },
      ],
      title: m.svc_n8n_limits_title(),
    },
    meta: {
      description: m.svc_n8n_meta_description(),
      title: m.svc_n8n_meta_title(),
    },
    nav: m.svc_n8n_nav(),
    scope: {
      body: m.svc_n8n_scope_body(),
      points: [
        m.svc_n8n_scope_point_1(),
        m.svc_n8n_scope_point_2(),
        m.svc_n8n_scope_point_3(),
        m.svc_n8n_scope_point_4(),
      ],
      title: m.svc_n8n_scope_title(),
    },
    serviceType: "n8n automation and AI workflow automation",
    slug: "n8n-automation",
    steps: {
      body: m.svc_n8n_steps_body(),
      items: [
        m.svc_n8n_step_1(),
        m.svc_n8n_step_2(),
        m.svc_n8n_step_3(),
        m.svc_n8n_step_4(),
      ],
      title: m.svc_n8n_steps_title(),
    },
    title: [m.svc_n8n_title_1(), m.svc_n8n_title_2()],
    uses: [
      {
        term: m.svc_n8n_use_1_term(),
        value: m.svc_n8n_use_1_value(),
      },
      {
        term: m.svc_n8n_use_2_term(),
        value: m.svc_n8n_use_2_value(),
      },
      {
        term: m.svc_n8n_use_3_term(),
        value: m.svc_n8n_use_3_value(),
      },
      {
        term: m.svc_n8n_use_4_term(),
        value: m.svc_n8n_use_4_value(),
      },
    ],
  };
}
